<template>
  <MDBCard class="mb-3 mb-lg-4 welcome--main welcome__height" :class="[
    props.boxHeight
  ]">
    <MailBoxContent v-if="useTyreBoxLeftColumnLayout" />
    <WelcomeBoxContent v-else />
  </MDBCard>

  <TyreBox v-if="showTyreBox" />
  <MailBox v-else-if="tenantConfig?.showMailBox && canSeeMailbox" />
</template>

<script setup>
import { MDBCard } from "mdb-vue-ui-kit";
import MailBox from "@/components/Dashboard/MailBox.vue";
import TyreBox from "@/components/Dashboard/TyreBox.vue";
import WelcomeBoxContent from "@/components/Dashboard/WelcomeBoxContent.vue";
import MailBoxContent from "@/components/Dashboard/MailBoxContent.vue";
import { useStore } from "vuex";
import { computed, watch, ref, onMounted } from "vue";
import { defineProps } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useItemsConditions } from "@/composables/useItemsConditions";
import TokenService from "@/services/storage.service";

const props = defineProps({
  boxHeight: { type: String, default: "welcome__height" },
});
const store = useStore();
const { tenantConfig } = useTenantConfig();
const { canSeeMailbox } = useItemsConditions();

const user = computed(() => store.getters.getMe);
const fetchLedtColumn = computed(() => store.getters.getFetchLeftColumn);
const meIsPending = computed(() => store.getters.getIsMePending);
const permissions = computed(() => store.getters.getPermissions);
const useTyreBoxLeftColumnLayout = computed(
  () => tenantConfig.value?.useTyreBoxLeftColumnLayout ?? false
);
const showTyreBox = computed(
  () =>
    useTyreBoxLeftColumnLayout.value &&
    permissions.value &&
    TokenService.showElement("tyreBox.see")
);

const isWholesaler = ref(false);
const isWholesalerStaff = ref(false);
const isStaff = ref(false);

watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "wholesalerStaff")) {
    isWholesalerStaff.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "staff")) {
    isStaff.value = true;
  }
});


onMounted(async () => {
  if (!fetchLedtColumn.value) {
    if (!user.value?.id && !meIsPending.value) {
      await store.dispatch("me");
    }
    store.dispatch("checkLeftColumnFetched");
  }

})
</script>

<style scoped lang="scss">
@import "@/styles/left_column.scss";
</style>
